import { render, staticRenderFns } from "./TacheMapping.vue?vue&type=template&id=16075f1f&scoped=true"
import script from "./TacheMapping.vue?vue&type=script&lang=js"
export * from "./TacheMapping.vue?vue&type=script&lang=js"
import style0 from "./TacheMapping.vue?vue&type=style&index=0&id=16075f1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16075f1f",
  null
  
)

export default component.exports